// Auto-generated file.
// Don't edit/delete it manually!

import type {ComponentProps, ComponentType} from 'react';
import React, {forwardRef} from 'react';

const WORD = forwardRef((props, ref) => {
    return (
        
<svg {...props} version="1.1" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
<path fill="#2a5699" d="M6.586 0v1.042c1.356 0.008 2.71-0.015 4.065 0.008 0.288-0.030 0.515 0.201 0.488 0.497 0.022 2.565-0.005 5.131 0.013 7.697-0.013 0.263 0.026 0.555-0.123 0.788-0.185 0.135-0.425 0.118-0.64 0.129-1.267-0.007-2.535-0.004-3.802-0.004v1.042s-4.655-0.694-6.587-1.043c-0.002-3.038 0-6.075 0-9.112 1.942-0.348 6.585-1.043 6.585-1.043z"></path>
<path fill="#fff" d="M6.586 1.432h4.18v8.333h-4.18v-1.041h3.294v-0.521h-3.294v-0.652h3.294v-0.52h-3.294v-0.651h3.294v-0.521h-3.294v-0.652h3.294v-0.521h-3.294v-0.651h3.294v-0.521h-3.294v-0.652h3.294v-0.521h-3.294v-0.911zM2.618 3.733c0.24-0.014 0.481-0.025 0.722-0.037 0.169 0.879 0.341 1.756 0.523 2.632 0.143-0.904 0.301-1.805 0.455-2.707 0.253-0.009 0.507-0.022 0.759-0.039-0.287 1.262-0.537 2.534-0.85 3.788-0.212 0.114-0.529-0.005-0.78 0.014-0.168-0.862-0.364-1.719-0.515-2.584-0.148 0.841-0.341 1.674-0.51 2.51-0.244-0.013-0.488-0.029-0.733-0.045-0.21-1.146-0.457-2.284-0.653-3.433 0.216-0.011 0.434-0.019 0.651-0.028 0.13 0.83 0.278 1.655 0.392 2.486 0.179-0.852 0.361-1.703 0.539-2.555z"></path>
</svg>

    );
}) as ComponentType<ComponentProps<'svg'>>;

export default WORD;
